import { useSSRFlags } from '@kiwicom/overlord/src/contexts/SSRFlagsContext';

const useIsMobileApp = () => {
  const { isAndroid, isIos } = useSSRFlags();

  return isAndroid || isIos;
};

export default useIsMobileApp;
